export default {
	SET_CUSTOMERS: "SET_CUSTOMERS",
	CREATE_CUSTOMER: "CREATE_CUSTOMER",
	SET_LOADING: "SET_LOADING",
	EDIT_CUSTOMER: "EDIT_CUSTOMER",
	REMOVE_CUSTOMER: "REMOVE_CUSTOMER"
}